import ActionBar from './ActionBar';
import ActionBarV2 from '../ActionBar.actionbar_refactor';
import ActionBarContainer from './ActionBar.container';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    actionbar_refactor: ActionBarV2
})(ActionBarContainer(ActionBar));
